import { render, staticRenderFns } from "./SettingGoldBetweenSupportLevelsAndSkills.vue?vue&type=template&id=2a6c5507&scoped=true&"
import script from "./SettingGoldBetweenSupportLevelsAndSkills.vue?vue&type=script&lang=js&"
export * from "./SettingGoldBetweenSupportLevelsAndSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c5507",
  null
  
)

export default component.exports